'use strict';

const init = () => {
    if (document.body.classList.contains('tc-website-project')) {
        window.addEventListener('scroll', () => {
            const header = document.getElementById('main-header')
            if (header) {
                const pageIntroduction = document.querySelector('.tc-website-pageintroduction')

                if (window.scrollY >= pageIntroduction.offsetHeight) {
                    header.classList.remove('transparent-background');
                } else {
                    header.classList.add('transparent-background');
                }
            }
        })
    }
}

export default {init}
